import AddressProofError from './AddressProof/AddressProofError';
class IncorrectProofType extends AddressProofError {
    constructor(options) {
        super('Address proof type is invalid', options);
    }
}
export default IncorrectProofType;
